import React from "react";

import { Modal } from "react-bootstrap";

type PropsType = {
  showModal: boolean;
  handleModalToggle: Function;
  modalTitle: string;
};

export default function NotificationModal(props) {
  const { showModal, handleModalToggle, modalTitle } = props;
  return (
    <Modal show={showModal} onHide={handleModalToggle} dialogClassName="modal-90w" aria-labelledby="example-custom-modal-styling-title">
      <Modal.Header closeButton>
        <Modal.Title id="example-custom-modal-styling-title">{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body></Modal.Body>
    </Modal>
  );
}
